import React from 'react'
import Helmet from 'react-helmet'

import Layout from '../components/layout'
import HeaderFaq from '../components/HeaderFaq'
import pic04 from '../assets/images/carousel/habitee4.jpeg'

class Faq extends React.Component {
  render() {
    return (
      <Layout>
        <Helmet title="FAQ" />
        <HeaderFaq />
        <div id="main">
          <section id="content" className="main">
            <span className="image main">
              <img src={pic04} alt="" />
            </span>
            <h2>¿Qué necesito para reservar?</h2>
            <p>
              Lo único que necesitas es una tarjeta de crédito vigente, que
              puede ser de tus padres y una identificación oficial.
            </p>
            <h2>¿Tengo qué ser estudiante del Tec de Monterrey?</h2>
            <p>
              No, puedes ser estudiante de cualquier universidad de la ciudad de
              Querétaro.
            </p>
            <h2>¿Qué días se paga mensualidad?</h2>
            <p>
              Las mensualidades se pueden pagar el día primero, el quince o el
              treinta de cada mes con cargo a tarjeta de crédito.
            </p>
            <h2>¿Existe algún limite de edad para vivir en Habiteé?</h2>
            <p>
              Sí, en Habiteé puedes vivir desde los 18 hasta los 29 años de
              edad.
            </p>
          </section>
        </div>
      </Layout>
    )
  }
}

export default Faq
